<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Club
            </th>
            <th class="text-right">
              Comment
            </th>
            <th class="text-right">
              Approved Points
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="point in points" :key="point.id">
            <td v-if="point.club">
              {{ point.club.name }}
            </td>
            <td class="text-right">{{ point.comment }}</td>
            <td class="text-right">{{ point.points }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "ApprovedPoints",

  props: ["points"],
  components: {},

  data: () => ({
    loading: false,
  }),

  methods: {
    submit() {
      this.loading = true;
    },
    deleteTheme(id) {
      this.$emit("deleteTheme", id);
    },
  },
};
</script>
